import { useMemo } from "react";
import { Grid } from "@mui/material";

import Box from "../Box";
import Typography from "../Typography";
import AvatarPicker from "../AvatarPicker";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import ProfileService from "../../services/identity/profile.service";

import { ICodename, IUserProfile } from "../../commons/interfaces";


interface IHeaderInfoProps {
    idHref: string;
    userProfile: IUserProfile;
    listOrganization: ICodename[];
    onChangeAvatar: (data: { avatarUrl: string, avatarId: string }) => void;

    onError: (msg: string) => void;
    onSuccess: (msg: string) => void;
    onLoading: (value: boolean) => void;
}

const HeaderInfo = ({
    idHref,
    userProfile,
    listOrganization,
    onChangeAvatar,

    onError,
    onSuccess,
    onLoading,
}: IHeaderInfoProps) => {
    const strings = useStrings();

    const nameOrg = useMemo(() => {
        const item = listOrganization.find(el => el.code === userProfile?.organizationId);
        return item ? item?.name : "";
    }, [userProfile?.organizationId, listOrganization]);

    const handleChangeAvatar = async (avatarUrl: string, avatarId: string) => {
        if (Helpers.isNullOrEmpty(avatarUrl) && Helpers.isNullOrEmpty(avatarId)) return;

        try {
            onLoading(true);

            const result = await ProfileService.updateAvatar({ avatarId: avatarId, avatarUrl: avatarUrl });

            if (result.statusCode === 200) {
                onChangeAvatar({ avatarId: avatarId, avatarUrl: avatarUrl });
                onSuccess(strings.Profile.CHANGE_AVTAR_SUCCESS);
            }

            onLoading(false);
        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        }
    };

    return (
        <Box key={`hd`} id={idHref} p={2}>
            <Grid container spacing={1} alignItems="center">
                <Grid item xs={4} md={3}>
                    <AvatarPicker
                        name={userProfile?.fullName}
                        onChange={handleChangeAvatar}
                        src={
                            (Helpers.isNullOrEmpty(userProfile?.avatarUrl) || userProfile?.avatarUrl === "0")
                                ? undefined
                                : userProfile?.avatarUrl
                        }
                    />
                </Grid>
                <Grid item xs={8} md={8}>
                    <Box height="100%" mt={0.5} lineHeight={1}>
                        {
                            !Helpers.isNullOrEmpty(userProfile?.fullName) &&
                            <Typography variant="h5">
                                {userProfile?.fullName || ""}
                            </Typography>
                        }
                        {
                            !Helpers.isNullOrEmpty(userProfile?.roleName) &&
                            <Typography variant="button" >
                                {`${strings.Staff.ROLE}: `}
                                <Typography variant="button" fontWeight="bold">
                                    {userProfile?.roleName}
                                </Typography>
                            </Typography>
                        }
                        {
                            !Helpers.isNullOrEmpty(nameOrg) &&
                            <Box>
                                <Typography variant="button" >
                                    {`${strings.Common.ORGANIZATION}: `}
                                    <Typography variant="button" fontWeight="bold">
                                        {nameOrg}
                                    </Typography>
                                </Typography>
                            </Box>
                        }
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default HeaderInfo;